import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

interface IRequestEventChangeProps {
  locationId: string;
  eventId: string;
  artistId: string;
  startDate: string;
  endDate: string;
  title: string;
  organizerTweetId: string;
  posterDataUrls: string[];
  description: string;
  linkUrl: string;
  memberIds: string[];
}

export const requestEventChange = async ({
  locationId,
  eventId,
  artistId,
  startDate,
  endDate,
  title,
  organizerTweetId,
  posterDataUrls,
  description,
  linkUrl,
  memberIds
}: IRequestEventChangeProps) => {
  const response = await fetch(
    `${baseUrl()}/api/v1/locations/${locationId}/events/${eventId}/request_change`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`
      },
      body: JSON.stringify({
        event: {
          artist_id: artistId || '',
          start_date: startDate,
          end_date: endDate,
          name: title,
          organizer_tweet_id: organizerTweetId,
          poster_data_urls: posterDataUrls,
          description: description,
          link_url: linkUrl
        },
        member_ids: memberIds.length > 0 ? memberIds : []
      })
    }
  );

  return response;
};

interface IRequestFootprintChangeProps {
  footprintId: string;
  artistId: string;
  category: string;
  contentType: string;
  description: string;
  linkUrl: string;
  dataUrls: string[];
  memberIds: string[];
}

export const requestFootprintChange = async ({
  footprintId,
  artistId,
  category,
  contentType,
  description,
  linkUrl,
  dataUrls,
  memberIds
}: IRequestFootprintChangeProps) => {
  const response = await fetch(`${baseUrl()}/api/v1/footprints/${footprintId}/request_change`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      footprint: {
        artist_id: artistId,
        category: category,
        content_type: contentType,
        link_url: linkUrl,
        description: description,
        member_ids: memberIds.length > 0 ? memberIds : [],
        data_urls: dataUrls.length > 0 ? dataUrls : []
      }
    })
  });

  return response;
};
